<div class="mi-not-found-page d-flex flex-column align-items-center">
    <div>
        <img src="assets/images/general/error/not-found.svg" alt="404 error page">
    </div>
    <div>
        <p class="fw-bold">{{errorText?.notFoundErrorPage?.text}}</p>
    </div>
    <div>
        <small>{{errorText?.notFoundErrorPage?.smallText}}</small>
    </div>
</div>